module.exports = __webpack_public_path__ + "img/brand1.f9689abb.png";